export const OEM_CONFIG_CONTAINER_INVALID_CONFIG = 'OEMConfigContainer#validateSetConfigParams: invalid config';
